export default "__VITE_ASSET__KbHJWA8N__"